/** A customer's name, tagged when the account is still a prospect (no revenue or sensors yet). */
export function CustomerName({ name, status }: { name: string; status: string | null }) {
  return (
    <span>
      {name}
      {status === 'prospect' && (
        <span className="ml-1 rounded bg-muted px-1 py-px text-[10px] font-medium uppercase tracking-wide text-muted-foreground">
          prospect
        </span>
      )}
    </span>
  );
}
